import 'scss/services/niutrans.scss'
import 'babel-polyfill'
import { config } from 'config'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { getOtsResult } from 'js/api/services'
import 'js/libs/gt'
import { Base64 } from 'js-base64'

var trans = {
  config: {},
  data: {
    select: '',
    from: 'auto',
    fromText: '自动检测',
    to: 'en',
    toText: '英语',
    languageList: {
      'sq': '阿尔巴尼亚语',
      'ar': '阿拉伯语',
      'am': '阿姆哈拉语',
      'az': '阿塞拜疆语',
      'ee': '埃维语',
      'ga': '爱尔兰语',
      'et': '爱沙尼亚语',
      'om': '奥罗莫语',
      'os': '奥赛梯语',
      'tpi': '巴布亚皮钦语',
      'ba': '巴什基尔语',
      'eu': '巴斯克语',
      'be': '白俄罗斯语',
      'mww': '白苗文',
      'bg': '保加利亚语',
      'bi': '比斯拉马语',
      'bem': '别姆巴语',
      'is': '冰岛语',
      'pl': '波兰语',
      'nb': '博克马尔语',
      'tn': '茨瓦纳语',
      'ts': '聪加语',
      'bs': '波斯尼亚语',
      'fa': '波斯语',
      'tt': '鞑靼语',
      'da': '丹麦语',
      'de': '德语',
      'ru': '俄语',
      'fr': '法语',
      'fil': '菲律宾语',
      'fj': '斐济语',
      'fi': '芬兰语',
      'fy': '弗里西语',
      'kg': '刚果语',
      'km': '高棉语',
      'jy': '格鲁吉亚语',
      'gu': '古吉拉特语',
      'ka': '哈萨克语',
      'kk': '哈萨克语（西里尔）',
      'ht': '海地克里奥尔语',
      'ko': '韩语',
      'ha': '豪萨语',
      'nl': '荷兰语',
      'ky': '吉尔吉斯语',
      'gl': '加利西亚语',
      'ca': '加泰罗尼亚语',
      'cs': '捷克语',
      'kn': '卡纳达语',
      'kek': '凯克其语',
      'co': '科西嘉语',
      'otq': '克雷塔罗奥托米语',
      'hr': '克罗地亚语',
      'ku': '库尔德语',
      'la': '拉丁语',
      'lv': '拉脱维亚语',
      'lo': '老挝语',
      'lt': '立陶宛语',
      'ln': '林加拉语',
      'rn': '隆迪语',
      'lg': '卢干达语',
      'lb': '卢森堡语',
      'rw': '卢旺达语',
      'ro': '罗马尼亚语',
      'mg': '马尔加什语',
      'mt': '马耳他语',
      'mr': '马拉地语',
      'ml': '马拉雅拉姆语',
      'ms': '马来语',
      'mhr': '马里语',
      'mk': '马其顿语',
      'mi': '毛利语',
      'mn': '蒙古语（西里尔）',
      'bn': '孟加拉语',
      'my': '缅甸语',
      'af': '南非荷兰语',
      'xh': '南非科萨语',
      'zu': '南非祖鲁语',
      'ne': '尼泊尔语',
      'no': '挪威语',
      'pap': '帕皮阿门托语',
      'pa': '旁遮普语',
      'pt': '葡萄牙语',
      'ps': '普什图语',
      'ny': '齐切瓦语',
      'tw': '契维语',
      'ja': '日语',
      'sv': '瑞典语',
      'sm': '萨摩亚语',
      'sr': '塞尔维亚语',
      'crs': '塞舌尔克里奥尔语',
      'st': '塞索托语',
      'sg': '桑戈语',
      'si': '僧伽罗语',
      'mrj': '山地马里语',
      'eo': '世界语',
      'sk': '斯洛伐克语',
      'sl': '斯洛文尼亚语',
      'sw': '斯瓦希里语',
      'gd': '苏格兰盖尔语',
      'so': '索马里语',
      'tg': '塔吉克语',
      'ty': '塔希提语',
      'te': '泰卢固语',
      'ta': '泰米尔语',
      'th': '泰语',
      'to': '汤加语',
      'tig': '提格雷语',
      'tr': '土耳其语',
      'tk': '土库曼语',
      'war': '瓦瑞语',
      'cy': '威尔士语',
      'uy': '维吾尔语',
      'udm': '乌德穆尔特语',
      'ur': '乌尔都语',
      'uk': '乌克兰语',
      'uz': '乌兹别克语',
      'es': '西班牙语',
      'he': '希伯来语',
      'el': '希腊语',
      'haw': '夏威夷语',
      'sd': '信德语',
      'hu': '匈牙利语',
      'sn': '修纳语',
      'ceb': '宿务语',
      'hy': '亚美尼亚语',
      'ig': '伊博语',
      'it': '意大利语',
      'yi': '意第绪语',
      'hi': '印地语',
      'su': '印尼巽他语',
      'id': '印尼语',
      'jv': '印尼爪哇语',
      'en': '英语',
      'yua': '尤卡坦玛雅语',
      'yo': '约鲁巴语',
      'vi': '越南语',
      'yue': '（粤）广东话',
      'ti': '藏语',
      'zh': '中文（简体）',
      'cht': '中文（繁体）'
    }
  },
  bindEvent: function () {
    var self = this
    $(document).on('click', function () {
      $('.Lbox').hide()
    })
    $(document).find('.trans-select-button').on('click', function (e) {
      e.stopPropagation()
      self.data.select = $(this).attr('value')
      $(document).find('.Lbox-table li, .frequently-used-language li').removeClass('selected')
      if (self.data.select === 'trans_from_lan') {
        $('.frequently-used-language .auto-select').show()
        $('.Lbox-table, .frequently-used-language').find(`[value=${self.data.to}]`).addClass('selected')
      } else {
        $('.frequently-used-language .auto-select').hide()
        $('.Lbox-table, .frequently-used-language').find(`[value=${self.data.from}]`).addClass('selected')
      }
      $('.Lbox').show()
    })
    $(document).find('.Lbox').hover(function () {}, function () {
      $('.Lbox').hide()
    })
    $(document).find('.Lbox-table li, .frequently-used-language li').on('click', function (e) {
      e.stopPropagation()
      if ($(this).hasClass('selected')) { return false }
      self.methods.selectLanguage($(this).attr('value'), $(this).html())
    })
    $(document).find('#trans_text').on('keyup', function () {
      var len = $('#trans_text').val().length
      $(document).find('.trans-text-num').empty().html(`${len}/800`)
    })
    $(document).find('.form-to-icon').on('click', function () {
      if (self.data.from === 'auto') return false
      $('#trans_text').val('')
      $(document).find('.io-output .output').empty()
      self.methods.exchangeLanguage()
    })
  },
  methods: {
    selectLanguage (val, text) {
      $('.Lbox').hide()
      if (trans.data.select === 'trans_from_lan') {
        trans.data.from = val
        trans.data.fromText = text
        $('.trans-form-button span').replaceWith(`<span>${text}</span>`)
      } else {
        trans.data.to = val
        trans.data.toText = text
        $('.trans-to-button span').replaceWith(`<span>${text}</span>`)
      }
    },
    exchangeLanguage () {
      var temp = trans.data.from
      var tempText = trans.data.fromText
      trans.data.from = trans.data.to
      trans.data.to = temp
      trans.data.fromText = trans.data.toText
      trans.data.toText = tempText
      $('.trans-form-button span').replaceWith(`<span>${trans.data.fromText}</span>`)
      $('.trans-to-button span').replaceWith(`<span>${trans.data.toText}</span>`)
    },
    getResult (val) {
      $.mask()
      $(document).find('.io-output .output').empty()
      var params = {
        from: trans.data.from,
        to: trans.data.to,
        text: Base64.encode($.trim($('#trans_text').val())),
        challenge: val.geetest_challenge,
        validate: val.geetest_validate,
        seccode: val.geetest_seccode
      }
      getOtsResult(params).then(function (res) {
        $.mask('hide')
        if (res.code === 0 || res.code === '0') {
          trans.data.from = res.data.result.from
          trans.data.fromText = trans.data.languageList[trans.data.from]
          $('.trans-form-button span').replaceWith(`<span>${trans.data.fromText}</span>`)
          var str = `<div class="result">${res.data.result.trans_result.dst}</div>`
          $(document).find('.io-output .output').html(str)
        } else {
          $.alerts.alert(res.desc)
        }
      }).catch(function (errMsg) {
        $.mask('hide')
        $.alerts.alert(errMsg)
      })
    },
    // 极验Api1
    geetestApi1: function () {
      var self = trans
      $.ajax({
        url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 调用 initGeetest 进行初始化
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
          initGeetest({
            // 以下 4 个配置参数为必须，不能缺少
            gt: data.data.gt,
            challenge: data.data.challenge,
            offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机

            product: 'bind', // 产品形式，包括：float，popup
            width: '300px'
            // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
          }, function (captchaObj) {
            captchaObj.onReady(function () {
            }).onSuccess(function () {
              self.result = captchaObj.getValidate()
              if (!self.result) {
                return $.alerts.alert('请完成验证')
              }
              trans.methods.getResult(self.result)
            })
            $('#taste-button').click(function () {
              var text = $.trim($('#trans_text').val())
              if (!text) {
                $.alerts.alert('请输入需要翻译的内容')
              } else {
                captchaObj.verify()
              }
            })
          })
        }
      })
    }
  },
  init: function () {
    this.bindEvent()
  }
}

$(function () {
  trans.init()
  trans.methods.geetestApi1()
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).attr('package-id')
    let params = {
      wareId: '7001',
      packageId: packageId,
      serviceName: '机器翻译',
      businessId: 'ots'
    }
    goServiceBuy(params)
  })
  serviceQA()
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/niutrans.js